import React, {FC} from 'react';
import {TooltipProps, withStyles} from '@material-ui/core';
import {useTheme} from '@material-ui/core/styles';

import {getDirectionStyles} from '../../../../../../utils/ThemeUtils';
import Tooltip from '../../../../../../components/common/Tooltip';

const StyledPopover = withStyles(theme => ({
    popper: {
        pointerEvents: 'none'
    },
    tooltip: {
        margin: 0
    }
}))(Tooltip);

const TooltipPopover: FC<TooltipProps> = ({title, children}: TooltipProps) => {
    const theme = useTheme();

    return (
        <StyledPopover
            placement={getDirectionStyles(theme.direction)('top-start', 'top-end')}
            title={title}>
            {children}
        </StyledPopover>
    );
};

export default TooltipPopover;
